import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';

const pagesList1 = {
    colorNumber: '#e51908',
    list: [
        'Провели конкурентный анализ и&nbsp;собрали поведенческие факторы&nbsp;ЦА',
        'Собрали семантические ядра запросов',
        'Провели кластеризацию на&nbsp;группы',
    ],
};

const pagesList2 = {
    colorNumber: '#e51908',
    list: [
        'Подготовили ТЗ&nbsp;по&nbsp;текстам для новых или уже имеющихся страниц',
        'Создали контент по&nbsp;ТЗ и&nbsp;проверили, внесли корректировки',
        'Разместили текст на&nbsp;посадочных страницах сайта',
    ],
};

const Pages = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={0} animateOnce={true} duration={1}>
            <FullWrapper className="mts-invest-pages" bigPaddings={true}>
                <CommonTitle className="mts-invest-pages__title">
                    <div className="mts-invest-pages__title-decor">
                        <img
                            src="/images/svg/mts-invest/mts-invest-pages__title-decor.svg"
                            alt=""
                            loading="lazy"
                        />
                    </div>
                    <div>Оптимизация посадочных страниц</div>
                </CommonTitle>
                <div className="mts-invest-pages__info">
                    <CommonUsualText className="mts-invest-pages__info__title">
                        Проводим оптимизацию посадочных страниц, чтобы принять решение, как именно
                        в&nbsp;этой сфере оптимизировать страницы, какой выбрать подход, чтобы быть
                        достойным конкурентом в&nbsp;уже имеющейся выдачи.
                    </CommonUsualText>
                    <div className="mts-invest-pages__subtitle">
                        Для анализа сферы и&nbsp;подготовки к&nbsp;изменениям страниц, мы:
                    </div>
                    <CommonOlList CommonOlList={pagesList1} />
                    <div className="mts-invest-pages__subtitle">
                        Эти данные помогли нам составить рекомендации по&nbsp;доработке страниц для
                        решения задач пользователей. После анализа:
                    </div>
                    <CommonOlList CommonOlList={pagesList2} />
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Pages;
